export const TABLE_TYPES = {
	AWARD: "AWARD",
	AWARD_MODIFICATION: "AWARD_MODIFICATION",
	SUBAWARD: "SUBAWARD",
	SUBAWARD_MODIFICATION: "SUBAWARD_MODIFICATION",
	PROPOSAL: "PROPOSAL",
	TASK: "TASK",
};